import { render } from "./contactView.vue?vue&type=template&id=02174ef3&scoped=true"
import script from "./contactView.vue?vue&type=script&lang=js"
export * from "./contactView.vue?vue&type=script&lang=js"

import "./contactView.vue?vue&type=style&index=0&id=02174ef3&scoped=true&lang=css"

import exportComponent from "/home/beatriz/Documents/GitHub/virtus_consult/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02174ef3"]])

export default __exports__